const normalizeHTML = (html) => {
  if (typeof html !== "string") return html;

  return html
    .replace(/\s+/g, " ") // Collapse multiple spaces
    .replace(/&nbsp;/g, " ") // Replace non-breaking spaces
    .replace(/<p><br><\/p>/g, "") // Remove empty paragraphs
    .replace(/<p>\s*<\/p>/g, "") // Remove whitespace-only paragraphs
    .replace(/>\s+</g, "><") // Remove space between tags
    .trim(); // Trim leading/trailing whitespace
};

const extractTextfromHTMLElements = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return typeof tempDiv.textContent === "string"
    ? tempDiv.textContent.trim().replace(/\s+/g, "")
    : tempDiv.textContent;
};

const removeMathMLFractions = (html) => {
  if (typeof html !== "string") return html;
  return html.replace(/<mrow>\s*<mfrac>[\s\S]*?<\/mfrac>\s*<\/mrow>/gi, "");
};

const cleanMathMLArtifacts = (input) => {
  const isMatches = [...input.matchAll(/is(\d+)/g)];
  const evaluatedMatches = [...input.matchAll(/evaluated\(#\/#\)is\*!(\d+)/g)];

  const rawNumbers = [...isMatches, ...evaluatedMatches].map((m) => m[1]);

  const uniqueNumbers = [];
  rawNumbers.forEach((num) => {
    uniqueNumbers.forEach((existing) => {
      num = num.replace(existing, "");
    });
    if (num) uniqueNumbers.push(num);
  });

  uniqueNumbers.forEach((num) => {
    input = input.replace(new RegExp(num, "g"), "");
  });

  return input;
};

const sanitizeMathMLContent = (data) => {
  const cleaned = removeMathMLFractions(data);
  const extracted = extractTextfromHTMLElements(cleaned);
  const normalized = normalizeHTML(extracted);
  return cleanMathMLArtifacts(normalized);
};

/**
 * Compare if initialContent has an image and the newContent has an image,
 * if both images are equals return true.
 */
const hasContentEqualsInitialImage = (initialContent) => (newContent) => {
  const htmlParser = new DOMParser();

  const initialHTML = htmlParser.parseFromString(initialContent, "text/html");
  const newHTML = htmlParser.parseFromString(newContent, "text/html");

  const initialImg = initialHTML.querySelector("img");
  const newImg = newHTML.querySelector("img");

  if (initialImg) {
    if (!newImg) return false;

    const sameSrc = initialImg.src === newImg.src;
    const sameWidth = initialImg.width === newImg.width;
    const sameHeight = initialImg.height === newImg.height;

    return sameSrc && sameWidth && sameHeight;
  }

  return false;
};

export { sanitizeMathMLContent, hasContentEqualsInitialImage };
